/**
 * 2019-04-04
 * handan
 * 调查结果页面数据
 */

import { ajax } from "../utils/http/http";
import handleError from "../utils/handleError";
import { result } from "./mock.js";

let isMock = true ;
// 查询背调结果
const getVerifyResultData = async (batchId) => {
  let data = await ajax("/58/record/list/"+batchId)
  // if( isMock ) data = result ;
  if (data.code === "1") {
    return Promise.resolve(data.data) 
  } else {
    return handleError(data);
  }
}

// 查询支付点
const getPointSum = async ()=>{
  let data = await ajax("/58/common/getPoints");
  if(data.code==="1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data);
  }
}

// 生成订单方法 人民币
const fixWithMoney = async (params)=>{
  let data = await ajax("/58/record/fixWithMoney","POST",params)
  if(data.code==="1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}
// 生成订单方法 点
const queryWithPoints = async (params)=>{
  let data = await ajax("/58/record/queryWithPoints","POST",params)
  if(data.code==="1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}

// 查询用户名和身份证号
const getUserName = async (batchId) => {
  let data = await ajax("/58/batch/"+batchId);
  if(data.code==="1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data);
  }
}

// 支付成功后轮询接口
const getPayResult = async (orderId) => {
  let data = await ajax("/58/order/getPayResult/"+orderId,"POST");
  if(data.code==="1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data);
  }
}

// 查询会员权益次数接口 GET /58/common/getLevel
const getVipTime = async () => {
  let data = await ajax("/58/common/getRightsAmount");
  if(data.code==="1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data);
  }
}

const getVipTime2 = async () => {
  let data = await ajax("/58/common/getLevel");
  if(data.code==="1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data);
  }
}

// 会员免费重查
const getVipVerifyResultData = async (params) => {
  let data = await ajax("/58/record/queryWithLevelRight","POST",params);
  if(data.code==="1"){
    return Promise.resolve(data.data);
  }else{
    return handleError(data);
  }
}

export {
  getVerifyResultData,
  getPointSum,
  fixWithMoney,
  queryWithPoints,
  getUserName,
  getPayResult,
  getVipTime,
  getVipVerifyResultData,
  getVipTime2,
} 
